module.exports = __webpack_public_path__ + "img/T_cell_receptor.ae2540ba.png";